<template>
    <div class="home-page">
		<Header></Header>
		<div class="list" v-if="!notFound">
      <div class="list-menu">
        <span class="" v-for="(item,index) in listMenu" @click="getList(item)" :class="{'active':item==isShow}">
          {{item.name}}
        </span>
      </div>
      <div class="home1-product2">
        <div class="product2-content disflex">
          <div class="list-content" v-for="(item,index) in list">
            <div class="name-title ovhidden" @click="goPlay(item.game_id)">
              {{item.title}}
            </div>
            <div class="list-img">
              <img :src="item.icon_image" @click="goPlay(item.game_id)" />
            </div>
            <div class="list-center">
            </div>
            <button class="btn btn-blue" @click="goPlay(item.game_id)">{{$t('play')}}</button>
          </div>
        </div>
      </div>
      <div class="more ac mt20" v-if="isShow2" @click="getMore">
        <span>{{$t('showMore')}}</span>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {

    return {
			notFound:false,
			list:[],
			page:1,
			limit:5,
			isShow:'All',
			isShow2:true,
      listMenu:[],

		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
    this.getCategory()
	},
    methods: {
		back(){
			this.$router.push({path:'/index'})
		},
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
      let data = {
        'page':that.page,
        'limit':that.limit,
        'type_id':that.type_id
      }
			that.$api.post('/api/index/list',data,r =>{
				that.$parent.returnCode(r,function(){
					that.$parent.loadModal(false);
					if(r.data.length>0){
            if(that.page>1){
              that.list = that.list.concat(r.data)
            }else{
              that.list = r.data
            }
					}else{
						that.isShow2 = false;
						//that.$utils.alertText(that.$t('noMore'));
					}
          console.log(that.list)
        });

			})
		},
    getCategory(){
      let that = this
      that.$api.post('/api/index/category',null,r =>{
      	that.$parent.returnCode(r,function(){
      		//that.list = r.data.list
      		that.listMenu = r.data
          that.isShow = that.listMenu[0];
      		that.$parent.loadModal(false);
        });

      })
    },

    getList(item){
      this.isShow = item
      this.type_id = item.type_id
      this.list = []
      this.page = 1
      this.getHome();
    },
    goPlay(game_id){
      this.$router.push({path:'/game',query:{game_id:game_id}});
    },
		getMore(){
			let that = this;
			if(that.isShow2){
				that.page++;
				that.getHome();
			}else{
				that.$utils.alertText(that.$t('noMore'));
			}
		},
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/list.vue